<div class="row">

    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Teléfono De Casa:" [value]="(contactInformation.item('homePhone')) ? contactInformation.item('homePhone').value : ''" type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Teléfono De Oficina:" [value]="(contactInformation.item('officePhone')) ? contactInformation.item('officePhone').value : ''"
          type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Teléfono Celular:" [value]="(contactInformation.item('mobilePhone')) ? contactInformation.item('mobilePhone').value : ''"
          type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  
  </div>
  
  <div class="row">
  
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Correo Electrónico Laboral:" [value]="(contactInformation.item('workEmail')) ? contactInformation.item('workEmail').value : ''"
          type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
  
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Correo Electrónico Personal:" [value]="(contactInformation.item('personalEmail')) ? contactInformation.item('personalEmail').value : ''"
          type="text" [disabled]="disabled">
      </mat-form-field>
    </div>
    
  </div>